class SAccordion extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', this.initialize.bind(this));
  }

  initialize() {
    this.querySelectorAll('.accordion_headline').forEach((headline) => {
      headline.addEventListener('click', function () {
        const content = this.nextElementSibling;
        const svg = this.querySelector('.svg');
        if (
          content.style.maxHeight === '' ||
          content.style.maxHeight === '0px'
        ) {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.marginBottom = '16px';
          content.style.marginTop = '16px';
          svg.classList.add('rotate');
        } else {
          content.style.maxHeight = '0px';
          content.style.marginBottom = '0';
          svg.classList.remove('rotate');
        }
      });
    });
  }
}

window.customElements.define('s-accordion', SAccordion);
